import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 38 38"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M19 34.833c8.744 0 15.833-7.088 15.833-15.833 0-8.744-7.088-15.833-15.833-15.833-8.745 0-15.833 7.089-15.833 15.833 0 8.745 7.088 15.833 15.833 15.833ZM23.75 14.25l-9.5 9.5M14.25 14.25l9.5 9.5" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "close"}) } }